import React from "react";
import { ThemeProvider } from "@material-ui/styles";
import CssBaseline from "@material-ui/core/CssBaseline";
import { ThemeProvider as StyledTheme } from "styled-components";
import { MUITheme } from "./Theme";
import { GlobalStyle } from "./Partials/globalStyle";


const ThemeProviders = ({ children }) => {
  return (
    // <RTL>
    <ThemeProvider theme={MUITheme}>
      <StyledTheme theme={MUITheme}>
        <>
          <GlobalStyle />
          <CssBaseline />
          {children}
        </>
      </StyledTheme>
    </ThemeProvider>
    // </RTL>
  );
};

export { ThemeProviders };